import React, { useEffect, useState } from 'react'
import OrderHistoryCard from './OrderHistoryCard/OrderHistoryCard'
import classes from './OrderHistory.module.scss'
import { orderBy } from 'lodash-es'
import { DateTime } from 'luxon'
import { useShipStation } from '@/context/ShipStationContext'

export default function OrderHistoryPage({ customer }) {
  const [openOrders, setOpenOrders] = useState([])
  const [openOrdersLoaded, setOpenOrdersLoaded] = useState(false)
  const { shipByDates, fetchShipByDate, loading } = useShipStation()

  useEffect(() => {
    const load = async () => {
      const idArr = customer.id.split('/')
      const id = idArr[idArr.length - 1]
      // console.log('id: ', id);

      const result = await fetch(`/api/account/${id}/order-history`, {
        method: 'GET',
        headers: {
          'x-account-api-key': process.env.NEXT_PUBLIC_ACCOUNT_ENDPOINT_API_KEY,
        },
      }).then((res) => res.json())

      if (result.message === 'success') {
        const orders = orderBy(
          result.data ?? [],
          (order) => DateTime.fromISO(order.order_date).toFormat('yyyyMMdd'),
          ['desc'],
        )
        setOpenOrders(orders)
      }
      setOpenOrdersLoaded(true)
    }

    if (customer) load()
  }, [customer?.id])

  const renderLastOrder = (order) => {
    return <OrderHistoryCard order={order} startExpanded={true} />
  }

  const renderPreviousOrders = (orders) => {
    return orders.map((order, index) => {
      const cleanOrderNumber = order.order_number?.replace('#', '')
      const shipByDate = shipByDates[cleanOrderNumber]
      const isLoading = loading[cleanOrderNumber]

      return (
        <div key={`previous-orders-${index}`} className={classes['card']}>
          <OrderHistoryCard order={order} shipByDate={shipByDate} isLoading={isLoading} />
          {index + 1 !== orders.length && (
            <div className={classes['divider']}></div>
          )}
        </div>
      )
    })
  }

  const mostRecentOrder = openOrders[0]
  let previousOrders = []
  if (openOrders.length > 1) {
    previousOrders = openOrders.slice(1)
  }

  return (
    <div className={classes['order-history']}>
      {!openOrdersLoaded ? (
        <div>Loading...</div>
      ) : (
        <div>
          <h3>Last Order</h3>
          <div>
            {mostRecentOrder ? (
              renderLastOrder(mostRecentOrder)
            ) : (
              <div>You do not have any previous orders!</div>
            )}
          </div>

          {!!previousOrders?.length && (
            <div>
              <div className={classes['divider']}></div>
              <h3>Previous Orders</h3>
              <div>
                {previousOrders && renderPreviousOrders(previousOrders)}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
